// 🗺️ Edusense Roadmap 도메인 전용 클라이언트
// 완전 독립적인 Roadmap API 클라이언트 (deprecated edusense-client 사용 안함)

// 생성된 Roadmap API와 타입들을 export
// Orval이 생성한 Roadmap 관련 React Query hooks와 API 함수들
export * from './client_gen_gen_generated';

// Custom Axios instance export (Long 타입 ID 지원을 위해)
export { customInstance } from './custom-axios';